import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import {
  getList,
  getListSort,
  ListFilter,
  listSlice,
  ListType,
} from '../listHelper';
import { CancelToken } from 'axios';
import { DateFromTo } from '../../models/common';
import { accessPointLogService } from '@api/services/services';
import { AccessPointLogDto } from '@api/models/AccessPointLogDto';

export interface TurnstileLogsFilter extends ListFilter {
  supplierEmployee?: { id: string; name?: string };
  accessPointCode?: string;
  statusCode?: string;
  logType?: string;
  timestamp?: DateFromTo;
}

export type TurnstileLogsListState = ListType<AccessPointLogDto, TurnstileLogsFilter>;

const initialState: TurnstileLogsListState = {
  state: FetchState.None,
  data: undefined,
  query: {
    sortBy: 'timestamp',
    sortDesc: true,
  },
};

export const turnstileLogsListSlice = listSlice({
  name: 'turnstileLogsList',
  initialState,
});

export const selectTurnstileLogsList = (state: RootState) => state.turnstileLogsList;
export const turnstileLogsListActions = turnstileLogsListSlice.actions;

export const getTurnstileLogsList =
  (cancelToken: CancelToken) => (dispatch: AppDispatch) => {
    const storeState = store.getState();
    const data = selectTurnstileLogsList(storeState);

    const handleGetData = (size: number) => {
      return accessPointLogService.getAccessPointLogs({
        q: data.query.q,
        supplierEmployeeId: data.query.supplierEmployee?.id,
        accessPointCode: data.query.accessPointCode,
        statusCode: data.query.statusCode,
        logType: data.query.logType,
        timestampFrom: data.query.timestamp?.from,
        timestampTo: data.query.timestamp?.to,
        page: data.query.page,
        size,
        sort: getListSort(data),
      }, {
        cancelToken: cancelToken
      });
    };

    getList({
      dispatch,
      cancelToken,
      state: data.state,
      actions: turnstileLogsListActions,
      getData: handleGetData,
    });
  };

